import { ModalStatePresenter } from '@/presentation/presenters/modal/modalStatePresenter'
import { ModalStateViewModel } from '@/presentation/viewmodels/modal/modalStateViewModel'

export function useModalStatePresenter(
  presenter: ModalStatePresenter = new ModalStatePresenter(new ModalStateViewModel())
) {
  return {
    isShowLoginModal: presenter.isShowLoginModal,
    setIsShowLoginModal: presenter.setIsShowLoginModal.bind(presenter),
    reverseIsShowLoginModal: presenter.reverseIsShowLoginModal.bind(presenter),
    isShowProblemSearchModal: presenter.isShowProblemSearchModal,
    openProblemSearchModal: presenter.openProblemSearchModal.bind(presenter),
    setIsShowProblemSearchModal: presenter.setIsShowProblemSearchModal.bind(presenter),
    reverseIsShowProblemSearchModal: presenter.reverseIsShowProblemSearchModal.bind(presenter),
    isShowArenaModal: presenter.isShowArenaModal,
    setIsShowArenaModal: presenter.setIsShowArenaModal.bind(presenter),
    reverseIsShowArenaModal: presenter.reverseIsShowArenaModal.bind(presenter),
    isShowDashboardModal: presenter.isShowDashboardModal,
    setIsShowDashboardModal: presenter.setIsShowDashboardModal.bind(presenter),
    reverseIsShowDashboardModal: presenter.reverseIsShowDashboardModal.bind(presenter),
    isShowUpdateModal: presenter.isShowUpdateModal,
    setIsShowUpdateModal: presenter.setIsShowUpdateModal.bind(presenter),
    reverseIsShowUpdateModal: presenter.reverseIsShowUpdateModal.bind(presenter),
    isShowFreeSpaceModal: presenter.isShowFreeSpaceModal,
    setIsShowFreeSpaceModal: presenter.setIsShowFreeSpaceModal.bind(presenter),
    reverseIsShowFreeSpaceModal: presenter.reverseIsShowFreeSpaceModal.bind(presenter),
    isShowReviewAlertModal: presenter.isShowReviewAlertModal,
    setIsShowReviewAlertModal: presenter.setIsShowReviewAlertModal.bind(presenter),
    reverseIsShowReviewAlertModal: presenter.reverseIsShowReviewAlertModal.bind(presenter),
    isShowSettingsModal: presenter.isShowSettingsModal,
    setIsShowSettingsModal: presenter.setIsShowSettingsModal.bind(presenter),
    reverseIsShowSettingsModal: presenter.reverseIsShowSettingsModal.bind(presenter),
    isShowUserRegistrationModal: presenter.isShowUserRegistrationModal,
    setIsShowUserRegistrationModal: presenter.setIsShowUserRegistrationModal.bind(presenter),
    reverseIsShowUserRegistrationModal: presenter.reverseIsShowUserRegistrationModal.bind(presenter)
  }
}
